type FilmHistoryKey = "trailer" | "liked" | "pageview" | "preview" | "cart" | "checkout"

export type FilmHistory = {
  uri: string
  values: Record<FilmHistoryKey, number>
  lastUpdated: number
}

const KEY = "film-history"

const load = (): Record<string, FilmHistory> => {
  const data = localStorage?.getItem(KEY)
  if (!data) return {}
  try {
    return JSON.parse(data)
  } catch (e) {
    return {}
  }
}

const save = (data: Record<string, FilmHistory>) => {
  try {
    localStorage?.setItem(KEY, JSON.stringify(data))
  } catch (e) {}
}

export function trackFilmInterest(uri: string, type: FilmHistoryKey) {
  if (!env.client) return []
  if (!uri || !type) return
  const data = load()
  const film = data[uri] || { uri, values: {} }
  film.values[type] = (film.values[type] || 0) + 1
  film.lastUpdated = Date.now()
  data[uri] = film
  save(data)
  if (env.dev) {
    console.log("film-history", data)
  }
}

export function getLastViewedFilms() {
  if (!env.client) return []
  const items = load()
  return Object.values(items)
    .map((item) => {
      let score = 0

      score += item.values.trailer * 0.2 || 0
      score += item.values.liked * 0.5 || 0
      score += item.values.preview * 0.2 || 0
      score += item.values.cart * 1 || 0
      score += item.values.pageview * 1.5 || 0

      const age = Date.now() - item.lastUpdated
      score /= Math.max(0, Math.min(1, age / 1000 / 60 / 30))

      if (item.values.checkout || !item.lastUpdated) score = 0

      return {
        ...item,
        lastUpdatedString: new Date(item.lastUpdated).toLocaleString(),
        score: score,
      }
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.lastUpdated - a.lastUpdated)
    .slice(0, 8)
    .sort((a, b) => b.score - a.score)
}
